import { useState } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

import { Button, type ButtonProps } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const mapLocaleToCountryCode = (locale: string | undefined) => {
  switch (locale) {
    case "de":
      return "de";
    case "en":
      return "gb";
    default:
      return "gb"; // Default fallback
  }
};

/**
 * Sprachumschalter (Flaggen-Menü) — aus dem Header extrahiert, damit der
 * globale Header und der kompakte SiteHeader dieselbe Logik teilen.
 */
export function LanguageMenu({
  className,
  variant = "ghost",
  size = "icon",
}: {
  className?: string;
  variant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
}) {
  const { t, i18n } = useTranslation();
  const [locale, setLocale] = useState(i18next.resolvedLanguage);

  const changeLocale = (nextLocale: "de" | "en") => {
    setLocale(nextLocale);
    i18n.changeLanguage(nextLocale);
    localStorage.setItem("i18nextLng", nextLocale);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={variant}
          size={size}
          aria-label={t("header.changeLanguage")}
          className={className}
        >
          <span className={`fi fi-${mapLocaleToCountryCode(locale)}`}></span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => changeLocale("de")}>
          <span className="fi fi-de"></span>
          {t("header.german")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => changeLocale("en")}>
          <span className="fi fi-gb"></span>
          {t("header.english")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
